import type { Prototype } from "../prototype-types";

export const michaelZhangPrototypes: Prototype[] = [
  {
    id: "mz-signup-congratulation-animation",
    name: "Signup Congratulation Animation",
    path: "/mz/signup-congratulation-animation",
    description:
      "Replaces the aggressive post-signup 50% off modal with a new signup step — always the last one in the flow — plus an alternate passive on-site reminder, so the offer doesn't interrupt browsing.",
    owner: "Michael Zhang",
    createdAt: "2026-07-14",
    lastUpdated: "2026-07-14",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    thumbnail: "https://cdn.faire.com/fastly/5203c2930f6f5cf0058a4675b3c446d6f1917ea2f11560995b5e83bdce2bb472.png",
    creationTool: "claude-code",
  },
  {
    id: "mz-calculating-net-terms",
    name: "Calculating Net Terms",
    path: "/mz/calculating-net-terms",
    description: "Signup flow that pauses on a loading screen calculating the retailer&#39;s net terms, then reveals an approved net-60 limit as a celebratory gift before continuing.",
    owner: "Michael Zhang",
    createdAt: "2026-08-04",
    lastUpdated: "2026-08-04",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    thumbnail: "https://cdn.prerelease.faire.dev/fastly/699e71030d373c6c545d270c7b9494bc1de70ee84f4157afbddc9d4ff9a46fda.png",
    creationTool: "claude-code",
  }
];
